// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_Bb5iB","textarea":"index_textarea_0ca6p","btnWrap":"index_btnWrap_ljiWm","btnSubmit":"index_btnSubmit_kmQ0k"};